import { _ as V } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as b } from "@ucl/shared-component-foundations";
import { fordProIcons as I } from "@ucl/shared-icons";
import S, { useState as x, useEffect as D, useMemo as G } from "react";
import l from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as z } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as R } from "./useWindowSize.js";
import { jsx as c, jsxs as P } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
var H = ["$isVisible"], q = ["$isLastStep", "$isVisible"], B = ["$isActive", "$editable", "$isCompleted", "$error"], Q = ["$editable"], F = ["$isActive"], J = ["$isCompleted", "$editable"], K = ["$isVisible"], X = I.Checkmark, Y = I.CancelClose, Z = I.Edit, ee = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ProgressWrapper",
  componentId: "sc-1g4gpci-0"
})(["display:", ";flex-direction:", ";flex-grow:", ";height:", ";"], function(e) {
  return e.theme.components.progressTrackerVertical.ProgressWrapper.display;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressWrapper.flexDirection;
}, function(e) {
  var r = e.$isVisible, t = V(e, H);
  return r ? t.theme.components.progressTrackerVertical.ProgressWrapper.flexGrow.visible : t.theme.components.progressTrackerVertical.ProgressWrapper.flexGrow.default;
}, function(e) {
  var r = e.$isLastStep, t = e.$isVisible, o = V(e, q);
  return t || r ? o.theme.components.progressTrackerVertical.ProgressWrapper.height.visibleOrLastStep : o.theme.components.progressTrackerVertical.ProgressWrapper.height.default;
}), re = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ProgressStepWrapper",
  componentId: "sc-1g4gpci-1"
})(["display:", ";gap:", ";align-items:", ";width:", ";@media ", "{gap:", ";}"], function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepWrapper.display;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepWrapper.gap;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepWrapper.alignItems;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepWrapper.width;
}, b.tabletAndUp, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepWrapper.tabletAndUp.gap;
}), te = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ProgressStepIndicator",
  componentId: "sc-1g4gpci-2"
})(["width:", ";height:", ";border-radius:", ";box-sizing:", ";border:", ";background-color:", ";color:", ";display:", ";justify-content:", ";align-items:", ";transition:", ";transition-duration:", ";cursor:", ";", ";@media ", "{height:", ";width:", ";", ";}"], function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.width;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.height;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.borderRadius;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.boxSizing;
}, function(e) {
  return e.$error && e.$isActive ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.errorActive : e.$editable ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.editable : e.$error ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.error : e.$isActive || e.$isCompleted ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.activeCompleted : e.theme.components.progressTrackerVertical.ProgressStepIndicator.border.default;
}, function(e) {
  return e.$error && e.$isActive ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.errorActive : e.$isActive || e.$editable ? e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.activeOrEditable : e.theme.components.progressTrackerVertical.ProgressStepIndicator.backgroundColor.default;
}, function(e) {
  var r = e.$isActive, t = e.$editable, o = e.$isCompleted, d = e.$error, s = V(e, B);
  return t ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.editable : d && !r ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.errorNotActive : r ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.active : o ? s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.completed : s.theme.components.progressTrackerVertical.ProgressStepIndicator.color.default;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.display;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.justifyContent;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.alignItems;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.transition;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.transitionDuration;
}, function(e) {
  var r = e.$editable, t = V(e, Q);
  return r ? t.theme.components.progressTrackerVertical.ProgressStepIndicator.cursor.editable : t.theme.components.progressTrackerVertical.ProgressStepIndicator.cursor.default;
}, function(e) {
  return e.theme.components.progressTrackerVertical.mobileTypoGraphy;
}, b.tabletAndUp, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.tabletAndUp.height;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ProgressStepIndicator.tabletAndUp.width;
}, function(e) {
  return e.theme.components.progressTrackerVertical.commonTypoGraphy;
}), oe = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__Connector",
  componentId: "sc-1g4gpci-3"
})(["position:", ";left:", ";width:", ";border-radius:", ";background-color:", ";margin:", ";transition:", ";transition-duration:", ";@media ", "{left:", ";}"], function(e) {
  return e.theme.components.progressTrackerVertical.Connector.position;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.left;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.width;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.borderRadius;
}, function(e) {
  var r = e.$isActive, t = V(e, F);
  return r ? t.theme.components.progressTrackerVertical.Connector.backgroundColor.active : t.theme.components.progressTrackerVertical.Connector.backgroundColor.default;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.margin;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.transition;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.transitionDuration;
}, b.tabletAndUp, function(e) {
  return e.theme.components.progressTrackerVertical.Connector.tabletAndUp.left;
}), ie = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ContentWrapper",
  componentId: "sc-1g4gpci-4"
})(["display:", ";height:", ";"], function(e) {
  return e.theme.components.progressTrackerVertical.ContentWrapper.display;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ContentWrapper.height;
}), ne = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__Wrapper",
  componentId: "sc-1g4gpci-5"
})(["height:", ";display:", ";flex-direction:", ";"], function(e) {
  return e.theme.components.progressTrackerVertical.Wrapper.height;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Wrapper.display;
}, function(e) {
  return e.theme.components.progressTrackerVertical.Wrapper.flexDirection;
}), se = /* @__PURE__ */ l.label.withConfig({
  displayName: "progressTrackerVertical__LabelWrapper",
  componentId: "sc-1g4gpci-6"
})(["color:", ";cursor:", ";", ";"], function(e) {
  var r = e.$isCompleted, t = e.$editable, o = V(e, J);
  return t ? o.theme.components.progressTrackerVertical.LabelWrapper.color.editable : r ? o.theme.components.progressTrackerVertical.LabelWrapper.color.completed : o.theme.components.progressTrackerVertical.LabelWrapper.color.default;
}, function(e) {
  return e.$editable ? e.theme.components.progressTrackerVertical.LabelWrapper.cursor.editable : e.theme.components.progressTrackerVertical.LabelWrapper.cursor.default;
}, function(e) {
  return e.theme.components.progressTrackerVertical.commonTypoGraphy;
}), ae = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ChildrenWrapper",
  componentId: "sc-1g4gpci-7"
})(["display:", ";margin:", ";width:", ";@media ", "{margin-left:", ";}"], function(e) {
  var r = e.$isVisible, t = V(e, K);
  return r ? t.theme.components.progressTrackerVertical.ChildrenWrapper.display.visible : t.theme.components.progressTrackerVertical.ChildrenWrapper.display.default;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ChildrenWrapper.margin;
}, function(e) {
  return e.theme.components.progressTrackerVertical.ChildrenWrapper.width;
}, b.tabletAndUp, function(e) {
  return e.theme.components.progressTrackerVertical.ChildrenWrapper.tabletAndUp.marginLeft;
}), ce = /* @__PURE__ */ l.div.withConfig({
  displayName: "progressTrackerVertical__ChildrenContainer",
  componentId: "sc-1g4gpci-8"
})(["", ""], function(e) {
  return `
    display: ` + e.theme.components.progressTrackerVertical.ChildrenContainer.display + `;
    height: ` + e.theme.components.progressTrackerVertical.ChildrenContainer.height + `;
    width: ` + e.theme.components.progressTrackerVertical.ChildrenContainer.width + `;
    min-height: ` + (e.$isVisible ? e.theme.components.progressTrackerVertical.ChildrenContainer.minHeight.visible : e.theme.components.progressTrackerVertical.ChildrenContainer.minHeight.default) + `;
    `;
}), pe = function(r) {
  var t = r.children, o = r.activeStep, d = o === void 0 ? 1 : o, s = r.onEdit, n = r.type, m = n === void 0 ? "progress" : n, i = r.className, g = z({
    label: "ProgressTrackerVertical"
  }), u = S.Children.map(t, function(a, h) {
    if (/* @__PURE__ */ S.isValidElement(a) && a.type === A) {
      var p, k = a.props;
      return /* @__PURE__ */ S.cloneElement(a, {
        _stepIndex: h + 1,
        activeStep: d,
        onClick: s,
        markerText: m === "progress" ? "" + (h + 1) : k == null || (p = k.markerText) == null ? void 0 : p.substring(0, 2)
      });
    }
    return null;
  });
  return /* @__PURE__ */ c(ne, Object.assign({
    className: i
  }, g, {
    children: u
  }));
}, A = function(r) {
  var t = r.children, o = r.label, d = o === void 0 ? "Label" : o, s = r._stepIndex, n = s === void 0 ? 1 : s, m = r.activeStep, i = m === void 0 ? 1 : m, g = r.onClick, u = r.markerText, a = u === void 0 ? "" : u, h = r.error, p = h === void 0 ? !1 : h, k = x(n <= i), f = k[0], v = k[1], W = x(!1), T = W[0], y = W[1], L = R(), _ = L.width, C = _ < 600, $ = {
    height: C ? 16 : 20,
    width: C ? 16 : 20
  };
  D(function() {
    n <= i && v(!0);
  }, [i]);
  var E = function() {
    !C && n < i && y(!0);
  }, M = function() {
    n <= i && y(!1);
  }, N = function(j, O) {
    n < i && g && g(j, O);
  }, U = G(function() {
    return T && n < i ? /* @__PURE__ */ c(Z, Object.assign({}, $)) : p ? /* @__PURE__ */ c(Y, Object.assign({}, $)) : n < i ? /* @__PURE__ */ c(X, Object.assign({}, $)) : a;
  }, [T, n, i, p, a]);
  return /* @__PURE__ */ P(ee, {
    $isVisible: f,
    $isLastStep: !t,
    children: [/* @__PURE__ */ c(le, {
      markerContent: U,
      error: p,
      editable: T,
      index: n,
      activeStep: i,
      label: d,
      onMouseEnter: E,
      onMouseLeave: M,
      onClick: N
    }), /* @__PURE__ */ P(ie, {
      children: [t && /* @__PURE__ */ c(oe, {
        $isActive: i > n
      }), /* @__PURE__ */ c(ce, {
        $isVisible: f,
        children: /* @__PURE__ */ c(ae, {
          $isVisible: f,
          children: t
        })
      })]
    })]
  });
}, le = function(r) {
  var t = r.markerContent, o = r.label, d = r.onMouseEnter, s = r.onMouseLeave, n = r.onClick, m = r.index, i = r.activeStep, g = r.editable, u = g === void 0 ? !1 : g, a = r.error, h = a === void 0 ? !1 : a, p = i >= m, k = i === m;
  return /* @__PURE__ */ P(re, {
    onMouseEnter: d,
    onMouseLeave: s,
    onClick: function(v) {
      return n(v, m);
    },
    children: [/* @__PURE__ */ c(te, {
      $isActive: k,
      $isCompleted: p,
      $editable: u,
      $error: h,
      children: t
    }), /* @__PURE__ */ c(se, {
      $isCompleted: p,
      $editable: u,
      children: o
    })]
  });
};
pe.Step = A;
export {
  pe as ProgressTrackerVertical
};
